(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown-clock"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('norbites-campaign-timer')) {
  customElements.define('norbites-campaign-timer', class extends HTMLElement {
    connectedCallback() {
      const root = this.closest('.norbites-deal-section');
      const tick = () => {
        root.querySelectorAll('[data-campaign-end]').forEach(card => {
          const end = Date.parse(card.dataset.campaignEnd);
          if (!Number.isFinite(end)) return;
          const left = end - Date.now();
          card.hidden = left <= 0;
          const timer = card.querySelector('[data-campaign-timer]');
          if (timer && left > 0) timer.textContent = Math.floor(left / 86400000) + 'd ' + String(Math.floor(left / 3600000) % 24).padStart(2, '0') + 'h ' + String(Math.floor(left / 60000) % 60).padStart(2, '0') + 'm';
        });
      };
      tick();
      this.timer = setInterval(tick, 15000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
